import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollable", "left", "right"]

  connect() {
    this._checkScroll()

    this.resizeObserver = new ResizeObserver(() => this._checkScroll())
    this.resizeObserver.observe(this.scrollableTarget)
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  onScroll(e) {
    if (e.deltaY > 0) {
      this.scrollRight()
    } else {
      this.scrollLeft()
    }

    e.preventDefault()
    this._checkScroll()
  }

  scrollLeft() {
    this.scrollableTarget.scrollBy({
      left: -150,
      behavior: "smooth"
    })

    setTimeout(() => this._checkScroll(), 200)
  }

  scrollRight() {
    this.scrollableTarget.scrollBy({
      left: 150,
      behavior: "smooth"
    })

    setTimeout(() => this._checkScroll(), 200)
  }

  _checkScroll() {
    const el = this.scrollableTarget
    const hasHorizontalOverflow = el.scrollWidth > el.clientWidth
    const canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth
    const canScrollLeft = el.scrollLeft > 0

    this.leftTarget.classList.toggle("visible", hasHorizontalOverflow && canScrollLeft)
    this.rightTarget.classList.toggle("visible", hasHorizontalOverflow && canScrollRight)
  }
}
